import { html } from 'lit-html';
import { ifDefined } from 'lit-html/directives/if-defined';

import { parseIndexes } from '../utils';

export const actions = ({ columnIndex, rowIndex, row = {}, column }) => {
  if (row.hideActions) return '';

  const actionDetail = ({ dataset: { rowIndex, columnIndex, action } }) =>
    parseIndexes({
      action,
      column,
      columnIndex,
      index: rowIndex,
      row,
      rowIndex,
    });


  const actionTemplate = ({ columnIndex, rowIndex }) =>
    ({ event, icon, iconHeight, iconWidth, tooltip }) => {
      const button = html`
        <fc-button
            @click="${onActionClick}"
            class="actions"
            data-action="${event}"
            data-column-index="${columnIndex}"
            data-row-index="${rowIndex}"
            height="${iconHeight || 16}"
            icon="${icon}"
            tooltip="${ifDefined(tooltip)}"
            width="${iconWidth || 16}"
        ></fc-button>
      `;

      return (
          !tooltip ? button
        : html`<fc-tooltip tooltip="${tooltip}">${button}</fc-tooltip>`
      );
    };

  function onActionClick({ target }) {
    target.dispatchEvent(new CustomEvent('table-action', {
      bubbles: true,
      composed: true,
      detail: actionDetail(target),
    }));
  }

  return column.actions.map(actionTemplate({ columnIndex, rowIndex, row }));
};
